import { z } from 'zod'

export const lifecycleEventNames = ['created', 'updated', 'moved', 'tagged'] as const
export const focusEventNames = ['entered', 'left'] as const
export const eventNames = [...lifecycleEventNames, ...focusEventNames] as const

export type LifecycleEvent = (typeof lifecycleEventNames)[number]
export type FocusEvent = (typeof focusEventNames)[number]
export type EventName = (typeof eventNames)[number]

export const eventSchema = z.enum(eventNames)

export function isLifecycleEvent(name: EventName): name is LifecycleEvent {
  return (lifecycleEventNames as readonly string[]).includes(name)
}
